import {
  Box,
  Button,
  DialogBackdrop,
  DialogBody,
  DialogContent,
  DialogPositioner,
  DialogRoot,
  Flex,
  Image,
  Text,
} from '@chakra-ui/react';

type Props = {
  open: boolean;
  previewUrl: string | null;
  uploading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ImageConfirmDialog({ open, previewUrl, uploading, onConfirm, onCancel }: Props) {
  return (
    <DialogRoot
      open={open && !!previewUrl}
      onOpenChange={({ open: isOpen }) => {
        if (!isOpen) onCancel();
      }}
    >
      <DialogBackdrop bg="blackAlpha.900" />
      <DialogPositioner display="flex" alignItems="center" justifyContent="center" p={4}>
        <DialogContent
          bg="white"
          boxShadow="xl"
          w="100%"
          maxW="min(480px, 100vw)"
          maxH="80vh"
          borderRadius="lg"
        >
          <DialogBody display="flex" flexDirection="column" gap={4} p={4}>
            <Text fontSize="sm" fontWeight="semibold">
              Send this photo?
            </Text>
            {previewUrl && (
              <Image
                src={previewUrl}
                alt="Photo preview"
                maxW="100%"
                maxH="50vh"
                objectFit="cover"
                borderRadius="md"
              />
            )}
            <Flex justify="flex-end" gap={2} mt={2}>
              <Button
                size="sm"
                variant="outline"
                onClick={onCancel}
                disabled={uploading}
                borderRadius="full"
                w={10}
                h={10}
                minW={10}
                aria-label="Cancel photo"
              >
                <Box as="span" display="flex" alignItems="center" justifyContent="center">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </Box>
              </Button>
              <Button
                size="sm"
                colorPalette="blue"
                onClick={onConfirm}
                loading={uploading}
                borderRadius="full"
                w={10}
                h={10}
                minW={10}
                aria-label="Send photo"
              >
                <Box as="span" display="flex" alignItems="center" justifyContent="center">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5 12H19M13 6L19 12L13 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Box>
              </Button>
            </Flex>
          </DialogBody>
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
}
